import { render, staticRenderFns } from "./AgentHistory.vue?vue&type=template&id=2f8b7e66&scoped=true&"
import script from "./AgentHistory.vue?vue&type=script&lang=js&"
export * from "./AgentHistory.vue?vue&type=script&lang=js&"
import style0 from "./AgentHistory.vue?vue&type=style&index=0&id=2f8b7e66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8b7e66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VIcon,
  VLayout,
  VList,
  VListTile,
  VListTileTitle,
  VMenu,
  VSpacer,
  VTextField,
  VTooltip,
})
